import { z } from 'zod';

export const createItemSearchSchema = z.object({
  createItem: z
    .preprocess((v: unknown) => v === 'true' || v === true, z.boolean().optional())
    .optional(),
  itemName: z.string().optional(),
});
